import { render, staticRenderFns } from "./TableRecord.vue?vue&type=template&id=d84f567e&scoped=true"
import script from "./TableRecord.vue?vue&type=script&lang=js"
export * from "./TableRecord.vue?vue&type=script&lang=js"
import style0 from "./TableRecord.vue?vue&type=style&index=0&id=d84f567e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84f567e",
  null
  
)

export default component.exports